import { ButtonBase, Grid, Box } from "@mui/material";
import ImageLoader from "../components/ImageLoader";
import CustomText from "../components/CustomText";
import { useContext } from "react";
import { ScreenContext } from "../context/ScreenContext";

const Header = ({ fulter, selected, handleClick, visible }) => {
  /**
   * Valores extraídos del contexto `ScreenContext`, que proporcionan información sobre la pantalla.
   * `isMobile` es un valor booleano que indica si la vista actual corresponde a un dispositivo móvil.
   * `dimensionHeight` es la altura de la ventana del navegador.
   * @type {{isMobile: boolean, dimensionHeight: number}} Un objeto con las propiedades `isMobile` y `dimensionHeight`.
   */
  const { isMobile } = useContext(ScreenContext);

  return (
    <Box sx={design.heroStyles(selected, isMobile)}>
      <Grid container justifyContent="center">
        {fulter.map((doc) => {
          const isActive = selected?.name === doc.name;
          return (
            <Grid
              item
              key={doc.name}
              sx={{ m: 1 }}
              pt={!isMobile ? 3 : 0}
              pb={!isMobile ? 5 : 0}
            >
              <ButtonBase
                onClick={() => handleClick(doc)}
                sx={{
                  backgroundColor: isActive
                    ? doc.color
                    : "rgba(255,255,255,0.12)",
                  border: isActive
                    ? `1px solid ${doc.color}`
                    : "1px solid rgba(255,255,255,0.45)",
                  boxShadow: isActive ? `0 8px 20px ${doc.color}33` : "none",
                  ...design.ButtonBase,
                }}
              >
                {doc.name}
              </ButtonBase>
            </Grid>
          );
        })}
      </Grid>

      <Grid
        container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: 5,
        }}
      >
        <CustomText
          color="#FFF"
          fontWeight={700}
          fontFamily="Nunito"
          sx={design.Title}
          textAlign="center"
          width="100%"
        >
          {selected?.name}
        </CustomText>
        <ImageLoader
          src={selected?.logo}
          alt={selected?.name}
          height={isMobile ? 118 : 200}
        />
      </Grid>
    </Box>
  );
};

export default Header;
const design = {
  Title: {
    fontSize: {
      xs: 30,
      sm: 36,
      md: 50,
      lg: 50,
    },
    lineHeight: "normal",
    marginTop: "5%",
    marginBottom: "5%",
  },
  ButtonBase: {
    fontFamily: "Nunito",
    padding: "8px 18px",
    borderRadius: "10px",
    fontWeight: 600,
    transition: "0.3s",
    marginLeft: 1,
    marginRight: 1,
    color: "#fff",
    fontSize: {
      xs: 13,
      sm: 14,
      md: 15,
    },
  },
  Box: {
    position: "relative",
    width: "100%",
    transition: "opacity 0.5s ease",
  },
  heroStyles: (selected, isMobile) => ({
    backgroundColor: selected?.color || "#1B2559",
    backgroundImage: selected?.gradient
      ? `${selected.gradient}, url(${selected.image})`
      : `url(${selected.image})`,
    backgroundPosition: selected.backgroundPosition,
    backgroundSize: {
      xs: "cover",
      sm: "cover",
      md: "cover",
      lg: "cover",
      xl: "cover",
    },
    backgroundRepeat: "no-repeat",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    py: isMobile ? 2 : 4,
    minHeight: {
      xs: "20vh",
      sm: "75vh",
      md: "35vh",
      lg: "20vh",
      xl: "55vh",
    },
    position: "relative",
    overflow: "hidden",
  }),
};
